import { computed, inject, Injectable, Signal } from "@angular/core";
import { map } from "rxjs/operators";

import { ILevelGeneralListData } from "../../models/level-general-list-data";
import { ILevelGeneralListDto } from "../../models/level-general-list-dto";
import { Observable } from "rxjs";
import { _ListService } from "./_list.service";
import { autocomplete, IAutoComplete } from "src/app/features/shared/controls/models/auto-complete.model";

export function compareItems_dropdown(o1: IAutoComplete, o2?: IAutoComplete): boolean {
    return !o2 ? false : o1.itemId == o2.itemId;
}

@Injectable()
export abstract class _ListDropdownService<ListDto extends ILevelGeneralListDto, ListData extends ILevelGeneralListData>
    extends _ListService<ListDto, ListData>
{
    abstract listDropdown$$: Signal<IAutoComplete[]> | null;
    abstract listDropdown$: Observable<IAutoComplete[]> | null;
    
    abstract listData_toAutoComplete(list: ListData): IAutoComplete | null;

    protected _listDropdown$$ = computed(() => this._listDropdown_sort(this.listActive$$()));
    protected _listDropdown$ = this._listActive$.pipe(map(list => this._listDropdown_sort(list)));
    protected _listDropdown_sort(list: ListData[]): IAutoComplete[] {
        return list?.map(item => this.listData_toAutoComplete(item))
            ?.filter((v): v is IAutoComplete => !!v)
            .sort((a, b) => a[autocomplete.itemText] > b[autocomplete.itemText] ? 1 : -1);
    }
}